import { render, staticRenderFns } from "./pricing-table-icon.vue?vue&type=template&id=8987286c&scoped=true&"
import script from "./pricing-table-icon.vue?vue&type=script&lang=js&"
export * from "./pricing-table-icon.vue?vue&type=script&lang=js&"
import style0 from "./pricing-table-icon.vue?vue&type=style&index=0&id=8987286c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8987286c",
  null
  
)

export default component.exports